import React, { useState } from "react";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import Input from "../Base/Input";
// import { useNavigate } from "react-router-dom";
import SubmitButton from "../common/SubmitButton";
import { useNavigate, useLocation } from "react-router-dom";
import configData from "../../Config";
import Backdrop from "../common/Backdrop";
import BasicCheckbox from "../Base/BasicCheckbox";
import LoadingDots from "../Lottie/LoadingDots";
import { apis } from "../../services/apiService";
import { t } from "i18next";
import styles from "../../Style/Modules/signup.module.css";
import "../../Style/Theme/index.css";
import {
  VerifyMobile,
  isValidEmail,
  onlyNumeric,
  constant,
} from "../../utils/utils";
import { encryptApiData } from "../../utils/apiEncryption";
import AlertPopup from "../common/AlertPopup";
import { CONSTANTS } from "../../utils/constant";
import ContainerForm from "../../containers/ContainerForm";
import ContainerSubmitButton from "../common/ContainerSubmitButton";
import loginImg from "./tyger_logo_animation_loader.gif";

const initialdata = {
  phoneNumber: "",
  email: "",
};

const initialCheckedData = {
  consentCheck: false,
  termCheck: false,
};

export default function SignUpForm(disabledBackBtn = false) {
  disabledBackBtn = false;
  const navigate = useNavigate();
  let location = useLocation();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialdata);
  const [checkformData, setCheckFormData] = useState(initialCheckedData);
  const [mobileErr, setMobileErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [finalErr, setFinalErr] = useState("");

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e?.target?.name]: e?.target?.value,
    });
    if (e?.target?.name === "phoneNumber") {
      if (e?.target?.value && !VerifyMobile(e?.target?.value)) {
        setMobileErr("enter valid mobile number or should not start with 0");
      } else {
        setMobileErr("");
      }
    }
    if (e?.target?.name === "email") {
      if (e?.target?.value && !isValidEmail(e?.target?.value)) {
        setEmailErr("please enter valid email id");
      } else {
        setEmailErr("");
      }
    }
  };

  let handleCheckOne = (e) => {
    setCheckFormData({
      ...checkformData,
      [e?.target?.name]: e?.target?.checked,
    });
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        mn: formData?.phoneNumber,
        em: formData?.email,
        src: location.state.source,
        anch: location.state.anchor,
        pr: location.state.program,
        UserAcceptedTnC: checkformData?.termCheck,
        consentToShortTermWorkingCapital: checkformData?.consentCheck,
      };

      let resp = await apis.postApi(configData.API_URL + "OTP/SendOTP_SignUp", {
        request: encryptApiData(reqData),
      });

      let result = await resp.json();
      if (resp?.status === 200) {
        setLoading(false);
        let data = {
          mn: formData?.phoneNumber.trim(),
          AppId: result?.data,
          em: formData?.email.trim(),
          isEmail: false,
          anchor: location.state.anchor,
          program: location.state.program,
          source: location.state.source,
        };

        navigate("/otp_p", { state: data });
      }
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setLoading(false);
      setFinalErr(errorResult?.statusMessage);
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
    setFormData(initialdata);
    setCheckFormData(initialCheckedData);
  };

  // const navigate = useNavigate();
  let screenWitdh = window.innerWidth;
  let screenHeight = window.innerHeight;
  return (
    <>
      {/* <ContainerForm
        component="form"
        noValidate
        id="signUpForm"
        autoComplete="off"
        // onSubmit={handleSubmit}
        className={`${styles.Signup}`}
        title={"Sign up"}
        subtitle={"Enter your mobile number & email id"}
        icon={"/assets/terms.svg"}
      > */}
      <Box
        component="form"
        sx={{
          // p: "2px 2px",
          // mb: "10px",
          // top: "44%",
          marginTop: "300px",
          // width: 400,
          // width: "100%",
          width: "300px",
          bgcolor: "#e9e9e9",
          position: "absolute",
          backgroundColor: "#29417c",
          // px: 4,
        }}
      >
        <Input
          fullWidth
          className="loginPage inputbg_Th"
          type="tel"
          name="phoneNumber"
          value={formData?.phoneNumber}
          error={mobileErr}
          autoComplete="off"
          label="Mobile number"
          onChange={handleOnChange}
          mb={2}
        />
        {mobileErr && (
          <Box sx={{ ml: 2, mt: -2, mb: 0.5 }}>
            <Typography variant="p" color="subtitle" className="errorMsg_Th">
              {mobileErr}
            </Typography>
          </Box>
        )}
        <Input
          className="loginPage inputbg_Th"
          type="text"
          name="email"
          value={formData?.email}
          autoComplete="off"
          error={emailErr}
          label="Email Id"
          onChange={handleOnChange}
          mb={2}
        />
        {emailErr && (
          <Box sx={{ ml: 2, mt: -2 }}>
            <Typography variant="p" color="subtitle" className="errorMsg_Th">
              {emailErr}
            </Typography>
          </Box>
        )}
        {loading && (
          <Backdrop ax="center">
            <img
              src={loginImg}
              style={{
                backgroundColor: "#072b8240",
                // "#072b822b",
                // "#4c69b1",
                // opacity: "0.8",
                width: "200px",
                height: "150px",
                marginLeft: "25%",
                borderRadius: "10px",
              }}
            />
          </Backdrop>
        )}
        {finalErr && (
          <Backdrop ax="center">
            <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
          </Backdrop>
        )}
      </Box>
      {/* </ContainerForm> */}

      <Box
        sx={{
          position: "relative",
          // top: "72%",
          textAlign: "center",
        }}
      >
        <Typography sx={{ color: "#29417c", fontWeight: "bold" }}>
          Already have an account?
          <Button
            variant="text"
            onClick={() => !disabledBackBtn && navigate(-1)}
            sx={{
              color: "#29417c",
              textDecoration: "underline",
              fontWeight: "bold",
            }}
          >
            Login
          </Button>
        </Typography>
      </Box>
      <Box
        sx={{
          position: "relative",
          // top: "78%",
          // width: "425px",
          maxWidth: screenWitdh > 425 ? "425px" : `${screenWitdh}px`,
          height: "100vh",
          // height: screenHeight > 150 ? "150px" : `${screenHeight}px`,
          overflowY: "scroll",
          scrollbarWidth: "thin",
          // display: "none",
          px: 2,
          paddingBottom: "40px",
        }}
      >
        {/* <Box sx={{}}> */}
        <div mb={-2} mt={2}>
          <div className={`${styles.termsCon} subTitle_Th`}>
            <p>
              By clicking "Continue", I accept the{" "}
              <a
                style={{ color: "blue", textDecorationLine: "underline" }}
                href={`${configData?.GETFILE}PRIVACY_TC [ContactUs].pdf`}
                target="_blank"
              >
                T&C
              </a>{" "}
              of {CONSTANTS?.brandName?.smallCase} Capital Pvt. Ltd. ("TCPL")
              (Formerly Adani Capital Pvt. Ltd.) and agree to receive alerts &
              notificati-on via {CONSTANTS?.brandName?.smallCase} Capital Pvt.
              Ltd. SMS, Email and Business W-hatsapp Account services and
              hereby, authorize TCPL to:
            </p>
            <p>
              <span style={{ fontWeight: "bold" }}>1)</span> Fetch my KYC
              records from Central KYC Records ("CKYCR")
            </p>
            <p>
              <span style={{ fontWeight: "bold" }}>2)</span> Fetch my GST, PAN
              details from NSDL, GST portal or any other platform as deemed
              appropriate by TCPL
            </p>
            <p>
              <span style={{ fontWeight: "bold" }}>3)</span> Receive my credit
              information from CIBIL, CRIF and other credit bureaus (hereinafter
              referred as "bureau"). I hereby unconditionally consent to and
              instruct bureau to provide my credit information to me and TCPL.
            </p>
            {/* <ul>
              <li>Fetch my KYC records from Central KYC Records ("CKYCR")</li>
              <li>
                Fetch my GST, PAN details from NSDL, GST portal or any other
                platform as deemed appropriate by TCPL
              </li>
              <li>
                Receive my credit information from CIBIL, CRIF and other credit
                bureaus (hereinafter referred as "bureau"). I hereby
                unconditionally consent to and instruct bureau to provide my
                credit information to me and TCPL.
              </li>
            </ul> */}
          </div>
        </div>
        <div mb={10} mt={2} style={{ wordBreak: "break-all" }}>
          <div style={{ wordBreak: "break-all" }}>
            <BasicCheckbox
              name="consentCheck"
              checked={checkformData?.consentCheck}
              label={`By Signing up on the page I hereby give my consent to apply for Short-Term Working Capital Finance from ${CONSTANTS?.brandName?.smallCase} Capital Pvt. Ltd.`}
              onChange={handleCheckOne}
            />
          </div>
          <div className={styles.checkboxTermsCon}>
            <BasicCheckbox
              name="termCheck"
              checked={checkformData?.termCheck}
              label={"I agree to the terms & conditions"}
              onChange={handleCheckOne}
            />
          </div>
        </div>
        {/* </Box> */}
        {/* {NumberArray.includes(mobile) && (
          <SubmitButton hasNote="No" form="loginForm" disabled={disabled} />
        )} */}
        {/* <SubmitButton
          hasNote="No"
          form="loginForm"
          disabled={
            !formData?.phoneNumber ||
            mobileErr ||
            emailErr ||
            !checkformData?.termCheck ||
            !checkformData?.consentCheck
          }
        /> */}

        <ContainerSubmitButton
          type="submit"
          onClick={handleSubmit}
          disabled={
            !formData?.phoneNumber ||
            mobileErr ||
            emailErr ||
            !checkformData?.termCheck ||
            !checkformData?.consentCheck
          }
        />
      </Box>
    </>
  );
}
